import { Button } from "@/components/ui/hs-button";
import { GlitchScene } from "@webapp/components/glitch-scene";
import { Home, RotateCcw } from "lucide-react";
import { Link } from "react-router";

export function NotFound() {
  return (
    <main className="flex min-h-screen flex-col">
      <GlitchScene heading="404" label="Signal lost" className="min-h-screen flex-1">
        <h2 className="mt-6 text-2xl font-semibold sm:text-3xl">
          This page glitched out of existence
        </h2>
        <p className="mt-3 max-w-md text-balance text-muted-foreground">
          We hunted everywhere but couldn&apos;t catch this one live. It might have dropped offline,
          or the link took a wrong turn.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild variant="default">
            <Link to="/">
              <Home />
              Back to safety
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/dashboard">
              <RotateCcw />
              Go to dashboard
            </Link>
          </Button>
        </div>
      </GlitchScene>
    </main>
  );
}
